import { TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"

import { Modal, Button } from "rsuite"
import Constant from "../../../../../../../../constant"
import NegotiationService from "../../../../../../../services/NegotiationService"
import MuiDataTable from "../../../../../../../components/MuiDataTable"
import { Col, Form, InputGroup, Row } from "react-bootstrap"
import NegotiationOfferItemService from "../../../../../../../services/NegotiationOfferItemService"
import { GreyCard } from "../../../../../../../components/styled/Generalcard"
import styled from "styled-components"
import CurrencyInput from "../../../../../../../components/CurrencyInput"
import Buttonaction from "../../../../../../../components/Buttonaction"
import Formservice from "../../../../../../../services/Formservice"
import { isIDR, roundIDR } from "../../../../../../../services/utils/CurrencyUtil"
import NegotiationLog from "../negotiation-log-report/NegotiationLog"
import NegotiationReport from "../negotiation-log-report/NegotiationReport"
import { fetchProcurementVendorsWithoutPagination } from "../../../../../../../redux/action/procurementAction"
import { useParams } from "react-router-dom"
import toast from "react-hot-toast"
import CancelProcessIcon from "../../../../../../../assets/images/IconCloseProcess.svg"
import SubmitModal from "../../../../../../../components/Submitmodal"
import Texteditor from "../../../../../../../components/Texteditor"

const TotalPrice = (params) => {
   const {
      negotiationItems,
      lastOffer,
      fnHandleClose,
      negotiation,
      negotiationBatch,
      negotiationOffer,
      dataProcurement,
   } = params
   const dispatch = useDispatch()
   const negotiationService = new NegotiationService()
   const negotiationOfferItemService = new NegotiationOfferItemService()

   const { procurementId } = useParams()

   const modalCancelRef = useRef()

   const [vendorLastPrice, setVendorLastPrice] = useState(null)
   const [statuses, setStatuses] = useState([])
   const [offers, setOffers] = useState([])
   const [hasGeneratedBA, setHasGeneratedBA] = useState(false)
   const [copyNegotiationOffer, setCopyNegotiationOffer] = useState({
      negotiationId: null,
      fromAccountId: null,
      toAccountId: null,
      offer: 0,
      status: null,
   })
   const tableColumns = ["Item Code", "Item Name", "Needed Qty", "UOM"]

   useEffect(() => {
      if (negotiationBatch?.status === Constant.STATUS.ON_GOING) {
         getStatus()
      }

      dispatch(
         fetchProcurementVendorsWithoutPagination({ procurementId }, (res) => {
            // get this vendor last price
            const procVendor = res.data.find((vendor) => vendor._id == negotiation.vendorId)
            setVendorLastPrice(procVendor.lastPrice)
         }),
      )
   }, [])

   useEffect(() => {
      handlePayloadOffer(lastOffer)
      handleTotalOffer(lastOffer?.offer)
   }, [lastOffer])

   const handlePayloadOffer = (_lastOffer) => {
      const arr = []
      let payload
      const sortedItems = [...negotiationItems].sort((a, b) => {
         const prA = a?.procurementItem?.prNumber ?? ""
         const prB = b?.procurementItem?.prNumber ?? ""
         if (prA !== prB) return prA.localeCompare(prB)
         const lineA = a?.procurementItem?.prLine ?? 0
         const lineB = b?.procurementItem?.prLine ?? 0
         if (lineA !== lineB) return lineA - lineB
         return (a?.procurementItem?.itemCode ?? "").localeCompare(b?.procurementItem?.itemCode ?? "")
      })
      for (const item of sortedItems) {
         payload = {}
         payload.negotiationItemId = item._id
         payload.itemCode = item.procurementItem.itemCode
         payload.itemName = item.procurementItem.itemName
         payload.qty = item.procurementItem.quantity
         payload.minCapableQty = item.procurementItem.minCapableQty
         payload.UOM = item.procurementItem.uom
         payload.offer =
            negotiation.status === Constant.STATUS.ON_GOING || negotiation.status === Constant.STATUS.DONE
               ? negotiationBatch.status === Constant.STATUS.ON_GOING
                  ? item.lastPrice
                  : 0
               : 0
         payload.capableQty = item.procurementItem.minCapableQty

         if (_lastOffer) {
            const { offerItems } = _lastOffer
            for (const offerItem of offerItems) {
               if (offerItem.negotiationItem.procurementItemId === item.procurementItemId) {
                  payload.offer = offerItem.offer
                  payload.capableQty = offerItem.capableQty
               }
            }
         }

         arr.push(payload)
      }
      setOffers(arr)
      console.log()
   }

   const handleTotalOffer = (_lastOffer) => {
      if (!_lastOffer) return
      setCopyNegotiationOffer({ ..._lastOffer, offer: _lastOffer.offer })
   }

   const getStatus = () => {
      dispatch(
         negotiationService.findStatus(negotiation, negotiation.status, (res) => {
            setStatuses(res)
         }),
      )
   }

   const handleChangeOffer = (value) => {
      const _negoOffer = { ...copyNegotiationOffer }
      // Round to integer when IDR to prevent float total submissions
      _negoOffer.offer = isIDR(dataProcurement?.currency) ? roundIDR(value) : value
      setCopyNegotiationOffer(_negoOffer)
   }

   const handleChangeStatus = (status) => {
      if (status.to.description === Constant.STATUS.DONE) {
         if (!hasGeneratedBA) {
            toast.error("Please generate the BA (Berita Acara) report before ending the session")
            return
         }
         const totalOffer = copyNegotiationOffer.offer
         if (!totalOffer) {
            toast.error(
               <p>
                  Couldn't send <strong>0</strong> offer
               </p>,
               { duration: 10000 },
            )
            return
         }

         if (vendorLastPrice) {
            if (totalOffer < vendorLastPrice) {
               new Promise((resolve, reject) => {
                  dispatch(
                     negotiationOfferItemService.submitOffer(
                        negotiation,
                        copyNegotiationOffer,
                        offers,
                        negotiation.fromAccountId,
                        negotiation.toAccountId,
                        Constant.NEGOTIATION_STATUS_OFFER.OFFER,
                        (res) => {
                           if (res) {
                              dispatch(
                                 negotiationService.changeStatus(negotiation, status.to.description, (resp) => {
                                    closeMe()
                                 }),
                              )
                           }
                        },
                     ),
                  )
               })
                  .then(() => {})
                  .catch(() => {})
                  .finally(() => {})
            } else {
               toast.error("Final price must be lower than vendor's last price")
            }
         } else {
            new Promise((resolve, reject) => {
               dispatch(
                  negotiationOfferItemService.submitOffer(
                     negotiation,
                     copyNegotiationOffer,
                     offers,
                     negotiation.fromAccountId,
                     negotiation.toAccountId,
                     Constant.NEGOTIATION_STATUS_OFFER.OFFER,
                     (res) => {
                        if (res) {
                           dispatch(
                              negotiationService.changeStatus(negotiation, status.to.description, (resp) => {
                                 closeMe()
                              }),
                           )
                        }
                     },
                  ),
               )
            })
               .then(() => {})
               .catch(() => {})
               .finally(() => {})
         }
      } else {
         modalCancelRef.current.show({
            modalTitle: "",
            title: "Cancel Negotiation?",
            description: <p>Do you want to Cancel this negotiation?</p>,
         })

         // dispatch(
         //    negotiationService.changeStatus(negotiation, status.to.description, (resp) => {
         //       closeMe()
         //    }),
         // )
      }
   }

   const [cancelReason, setCancelReason] = useState("")
   const handleCancelNegotiation = () => {
      dispatch(
         negotiationService.changeStatus(
            { ...negotiation, cancelReason: cancelReason },
            Constant.STATUS.CANCELED,
            (resp) => {
               closeMe()
            },
         ),
      )
   }

   const closeMe = () => {
      fnHandleClose(true, true)
   }

   return (
      <>
         <GreyCard style={{ padding: "32px 18px" }} className="mx-4">
            <Row>
               <Col lg={10}>
                  <p style={{ fontSize: "18px", fontWeight: "500" }}>Negotiation Item</p>
               </Col>
            </Row>
            <hr style={{ borderColor: "#C4C4C4", marginTop: "18px" }} />
            <Modal.Body>
               <MuiDataTable.CustomTable
                  containerStyles={{
                     maxHeight: "360px",
                     "&::-webkit-scrollbar": {
                        height: "8px",
                     },
                     "&::-webkit-scrollbar-thumb": {
                        background: "#C4C4C4",
                     },
                     scrollbarWidth: "thin",
                     scrollbarColor: "#C4C4C4",
                  }}
               >
                  <TableHead>
                     <TableRow>
                        {tableColumns.map((column, index) => (
                           <TableCell
                              key={index}
                              align={`${index === 2 || index === 3 ? "right" : "left"}`}
                              className="py-2"
                              sx={{ whiteSpace: "nowrap", background: "#D0D6E0" }}
                           >
                              {column}
                           </TableCell>
                        ))}
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {offers.map((item, index) => (
                        <TableRow
                           key={index}
                           sx={{
                              background: "#F3F5F4",
                              "&:hover": {
                                 background: "transparent",
                              },
                           }}
                        >
                           <TableCell
                              className="py-2"
                              size="small"
                              sx={{
                                 whiteSpace: "nowrap",
                              }}
                           >
                              {item.itemCode}
                           </TableCell>
                           <TableCell
                              className="py-2"
                              size="small"
                              sx={{
                                 whiteSpace: "nowrap",
                              }}
                           >
                              {item.itemName}
                           </TableCell>
                           <TableCell
                              align="right"
                              className="py-2"
                              size="small"
                              sx={{
                                 whiteSpace: "nowrap",
                              }}
                           >
                              {Formservice.QuantityFormatter(item.qty)}
                           </TableCell>
                           <TableCell align="right">{item.UOM}</TableCell>
                        </TableRow>
                     ))}
                  </TableBody>
               </MuiDataTable.CustomTable>
               <Row className="px-0 mx-0 mt-4">
                  <Col lg={9} className="d-flex justify-content-end align-items-center mr-4">
                     <p style={{ fontWeight: "500" }}>Your final price</p>
                  </Col>
                  <Col className="d-flex justify-content-end" style={{ marginRight: "12px" }}>
                     {negotiation?.status !== Constant.STATUS.ON_GOING ||
                     negotiationBatch?.status !== Constant.STATUS.ON_GOING ? (
                        <p>
                           {Formservice.CurrencyFormatter(copyNegotiationOffer.offer, {
                              currency: dataProcurement?.currency,
                           })}
                        </p>
                     ) : (
                        <InputGroup>
                           <CurrencyInput
                              disabled={negotiation.status === Constant.STATUS.DONE}
                              className="form-control text-right"
                              placeholder="0"
                              value={copyNegotiationOffer.offer}
                              currency={dataProcurement?.currency}
                              onValueChange={(v) => handleChangeOffer(v)}
                           />
                           <InputGroupText>{dataProcurement?.currency}</InputGroupText>
                        </InputGroup>
                     )}
                  </Col>
               </Row>
            </Modal.Body>
         </GreyCard>

         {/* The code below is for BNI purpose */}
         {(negotiation.status === Constant.STATUS.ON_GOING || negotiation.status === Constant.STATUS.DONE) && (
            <NegotiationReport
               negotiationId={negotiation._id}
               finalNegotiationPrice={copyNegotiationOffer.offer}
               onReportGenerated={() => setHasGeneratedBA(true)}
            />
         )}
         {negotiation.status == "DONE" && (
            <NegotiationLog
               negotiationId={negotiation._id}
               finalNegotiationPrice={copyNegotiationOffer.offer}
               dataProcurement={dataProcurement}
            />
         )}
         {/* ================================= */}

         <Modal.Footer className="mx-4 mt-5 mb-4">
            {negotiation?.status === Constant.STATUS.ON_GOING &&
               negotiationBatch?.status === Constant.STATUS.ON_GOING && (
                  <div className="d-flex justify-content-end">
                     <div style={{ width: "380px" }}>
                        <Row className="mx-0">
                           {statuses.map((status, index) => {
                              const to = status.to.description
                              return (
                                 <Col
                                    key={index}
                                    className={`px-0 d-flex justify-content-end ${
                                       to === Constant.STATUS.CANCELED ? "order-1" : "order-2 pl-3"
                                    }`}
                                 >
                                    <Buttonaction
                                       red={to === Constant.STATUS.CANCELED}
                                       blueOcean={to !== Constant.STATUS.CANCELED}
                                       label={status.label}
                                       onClick={(e) => handleChangeStatus(status)}
                                       className="w-100"
                                    />
                                 </Col>
                              )
                           })}
                        </Row>
                     </div>
                  </div>
               )}
         </Modal.Footer>

         {/* CANCEL MODAL */}
         <SubmitModal.ModalContainer passedInRef={modalCancelRef} icon={CancelProcessIcon}>
            <div className="mt-4">
               <Texteditor
                  // data={formState.specification}
                  onValueChange={(v) => {
                     setCancelReason(v)
                  }}
               />
            </div>
            <SubmitModal.ModalButtonActions>
               <div className="mt-4 d-flex justify-content-end">
                  <div className="mr-3">
                     <Buttonaction
                        borderblueOcean
                        type="button"
                        label="No"
                        large
                        onClick={() => modalCancelRef.current.hide()}
                     />
                  </div>
                  <Buttonaction
                     disabled={!cancelReason}
                     blueOcean
                     type="button"
                     label="Yes"
                     large
                     // loading={isLoading}
                     onClick={handleCancelNegotiation}
                  />
               </div>
            </SubmitModal.ModalButtonActions>
         </SubmitModal.ModalContainer>
      </>
   )
}

export default TotalPrice

const InputGroupText = styled(InputGroup.Text)`
   margin-left: -3px;
   font-size: 12px;
   z-index: 0;
`
